import React from "react";
import { Button } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import { BiPencil } from "react-icons/bi";

const DroneList = ({
    user,
    selectedMachines,
    handleOpenMachineModal,
    handleRemoveMachine,
}) => {
    return (
        <div className="profile-cards mt-4" style={{ padding: "20px" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Machine Details</h5>
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleOpenMachineModal()}
                >
                    + Add Machine
                </button>
            </div>

            <div className="d-flex flex-wrap gap-3">
                {selectedMachines.length === 0 && (
                    <p className="text-muted">No machines added yet.</p>
                )}
                {selectedMachines.map((machine, idx) => (
                    <div
                        key={idx}
                        className="card d-flex flex-row overflow-hidden shadow-sm"
                        style={{ width: "310px", border: "1px solid #e0e0e0" }}
                    >
                        <div
                            style={{
                                width: "80px",
                                background: "#f8f9fa",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "80px",
                                overflow: "hidden",
                            }}
                        >
                            {machine.image ? (
                                <img
                                    src={
                                        machine.image.startsWith("http")
                                            ? machine.image
                                            : `${user?.baseS3Url}${machine.image}`
                                    }
                                    alt={machine.model}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            ) : (
                                <span className="text-muted small">N/A</span>
                            )}
                        </div>
                        <div className="p-2 d-flex flex-column justify-content-center flex-grow-1">
                            <h6
                                className="mb-1 text-truncate"
                                style={{ maxWidth: "150px" }}
                            >
                                {machine.model || machine.name}
                            </h6>
                            <small className="text-muted mb-0">
                                Make: {machine.make || machine.manufacturer}
                            </small>
                            <small className="text-muted">Type: {machine.type}</small>
                        </div>
                        <div
                            className="d-flex flex-column justify-content-center gap-2 p-2 border-start bg-light"
                            style={{ width: "45px", minHeight: "80px" }}
                        >
                            <Button
                                variant="link"
                                className="p-0 text-primary border-0 shadow-none d-flex justify-content-center"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenMachineModal(machine, idx);
                                }}
                                title="Edit"
                            >
                                <BiPencil size={18} />
                            </Button>

                            <Button
                                variant="link"
                                className="p-0 text-danger border-0 shadow-none d-flex justify-content-center"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveMachine(idx);
                                }}
                                title="Delete"
                            >
                                <IoMdClose size={18} />
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DroneList;
